import React, { ComponentProps } from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import Image from 'components/Common/Image'

const TileImage = styled(Image)`
  grid-column: 1 / -1;
  grid-row: 1 / -1;

  &.extraPadding img {
    padding: 0.75rem;
    box-sizing: border-box;
  }
`

interface Props extends Pick<ComponentProps<typeof Image>, 'objectFit'> {
  image: App.Image
  applyImagePadding?: boolean
}

function CartReviewTileImageContent(props: Props) {
  const { applyImagePadding, ...imageProps } = props

  return <TileImage
    fit="center"
    width={190}
    dpr={2}
    {...imageProps}
    role="presentation"
    className={clsx({ extraPadding: applyImagePadding })}
  />
}

export default CartReviewTileImageContent
